import css from 'styled-jsx/css'

export const RadioButtonStyle = css`
.custom-control {
    position: relative
}
.custom-control > input {
    position: absolute;
    top: 3px;
    left: 1px;
    padding: 12px;
    z-index: 2;
    cursor: pointer;
}
`
